import { Suspense, lazy } from 'react'
import { Helmet } from 'react-helmet-async'
import { LandingNav } from '@/ui/components/landing/sections/LandingNav'
import { LandingHero } from '@/ui/components/landing/sections/LandingHero'
import { IntroSection } from '@/ui/components/landing/sections/IntroSection'
import { SharingSection } from '@/ui/components/landing/sections/SharingSection'
import { GallerySection } from '@/ui/components/landing/sections/GallerySection'
import { PricingSection } from '@/ui/components/landing/sections/PricingSection'
import { ClosingSection, LandingFooter } from '@/ui/components/landing/sections/ClosingSection'
import '@/ui/components/landing/landing.css'

const TripBuilderSection = lazy(() => import('@/ui/components/landing/wizard/TripBuilderSection'))

function WizardSkeleton() {
  return (
    <div id="trip-builder" className="pt-[var(--l-section)]" aria-hidden>
      <div className="l-frame">
        <div className="h-[640px] bg-landing-surface" />
      </div>
    </div>
  )
}

export default function LandingPage() {
  return (
    // `.dark` scopes every dark: variant + inverted token to this page only,
    // independent of the app theme toggle on <html>
    <div className="dark landing-theme relative min-h-svh">
      <Helmet>
        <link rel="preload" href="/fonts/switzer-var.woff2" as="font" type="font/woff2" crossOrigin="anonymous" />
      </Helmet>

      <LandingNav />

      <main>
        <LandingHero />
        <IntroSection />

        {/* The interactive trip-builder wizard */}
        <Suspense fallback={<WizardSkeleton />}>
          <TripBuilderSection />
        </Suspense>

        <SharingSection />
        <GallerySection />
        <PricingSection />
        <ClosingSection />
      </main>

      <LandingFooter />
    </div>
  )
}
